import { useRouterArea } from '@/common/auth/userRouterArea'

import converxFunnelAPI, { coverxAPI, realAxiosInstance } from './api'

// Auth Check
export const getEmail = () => {
  return converxFunnelAPI.get(
    import.meta.env.DEV || true ? '/email' : '/broker/logged-user'
  )
}

// Step4 || Step7
export const postForQuote = (params: any) => {
  return realAxiosInstance.post(`/quotes/new`, { ...params })
}

// Step7
export const getLookUpPostCode = (params: { postCode: string }) => {
  return import.meta.env.DEV
    ? converxFunnelAPI.get(`/postcodes/lookup`)
    : realAxiosInstance.get(`/postcodes/lookup/${params.postCode}`)
}

export const retrievePostCode = (params: { code: string }) => {
  return import.meta.env.DEV
    ? converxFunnelAPI.get(`/postcodes/retrieve`)
    : realAxiosInstance.get(`/postcodes/retrieve/${params.code}`)
}

/**
 * Retrieves data for a commercial combined broker with the given GUID.
 *
 * @param {string} guid - The GUID of the commercial combined broker.
 * @return {Promise<AxiosResponse>} The response from the API.
 */
export const getDataWithGuid = (guid: string) => {
  return realAxiosInstance.get(`/broker/commercial-combined/${guid}`)
}

export const getDataWithBackofficeGuid = (guid: string) => {
  return realAxiosInstance.get(`/back-office/commercial-combined/${guid}`)
}

export const getClientDataWithGuid = (clientId: string) => {
  return realAxiosInstance.get(
    `/back-office/commercial-combined/client/${clientId}`
  )
}
export const getCommercialCombinedOptions = () => {
  return coverxAPI.get('/funnel/commercial-combined/options')
}

export const quotesSubmit = ({
  params,
}: {
  params: { guid: string | undefined; data: {} }
}) => {
  const { urlPrefix } = useRouterArea()
  return realAxiosInstance.post(
    `${urlPrefix}/quotes/new/submit/${params?.guid || ''}`,
    {
      ...params.data,
    }
  )
}

export const newQuotesSubmit = (params: any) => {
  const { urlPrefix } = useRouterArea()

  return realAxiosInstance.post(
    `${urlPrefix}/quotes/submit/new/${params?.brokerId}/${params?.clientId || ''}`,
    { ...params.data }
  )
}
export const backOfficeNewQuotesSubmit = (params: any) => {
  const { urlPrefix } = useRouterArea()

  return realAxiosInstance.post(
    `${urlPrefix}/quotes/new/submit/new/${params?.brokerId}/${params?.clientId || ''}`,
    { ...params.data }
  )
}
